var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7393 15.05L11.7693 1.02C10.9993 -0.34 8.99927 -0.34 8.21927 1.02L0.259271 15.05C-0.490729 16.37 0.489271 18 2.02927 18H17.9693C19.5193 18 20.4893 16.37 19.7393 15.05ZM9.23927 5C9.23927 4.59 9.57927 4.26 9.99927 4.26C10.4193 4.26 10.7593 4.59 10.7593 5V10.8C10.7593 11.21 10.4193 11.54 9.99927 11.54C9.57927 11.54 9.23927 11.21 9.23927 10.8V5ZM9.99927 14.77C9.43927 14.77 8.98927 14.33 8.98927 13.78C8.98927 13.23 9.43927 12.79 9.99927 12.79C10.5593 12.79 11.0093 13.23 11.0093 13.78C11.0093 14.33 10.5593 14.77 9.99927 14.77Z",
    fill: "#BA1F1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error-triangle.57051fe76a41d74b5b1487e79a97f1ec.svg";
export { ForwardRef as ReactComponent };